<div>
    <button mat-raised-button
            color="primary"
            (click)="authService.authWithGoogle()">
        Login with Google
    </button>
</div>
